import React from "react";

const ValidationText = (props) => {
  return props.error ? (
    <div
      className="validation-text"
      style={{ color: "#c00000", fontSize: "12px", lineHeight: "1.07" }}
    >
      {props.error}
    </div>
  ) : null;
};

export default ValidationText;
